import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShrinkComponent } from './shrink/shrink.component';
import { DetailedViewComponent } from './detailed-view/detailed-view.component';
import { MatSnackBarModule } from '@angular/material';
import { OnHoverDescribeDirective } from '../pages/checkout-process/on-hover-describe.directive';
import { PaidPipe } from './paid.pipe';

@NgModule({
  declarations: [ShrinkComponent, DetailedViewComponent,OnHoverDescribeDirective, PaidPipe],
  imports: [
    CommonModule,
    MatSnackBarModule
  ],
  exports:[ShrinkComponent, DetailedViewComponent, OnHoverDescribeDirective, PaidPipe]
})
export class UtilsModule { }
